import React from "react";
import "./TrustAndExcellenceStyle.scss";
import { trustAndExcellenceTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import CustomTabs from "../Common_UI_Kit/CustomTabs";
import { useNavigate } from "react-router-dom";

const TrustAndExcellenceSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="trust-and-excellence-section">
      <div className="trust-and-excellence-wrap">
        <SectionHeading>{trustAndExcellenceTextContent.headingText}</SectionHeading>

        <div className="trust-and-excellence-box">
          <p className="para-text">{trustAndExcellenceTextContent.paraText}</p>

          <div className="trust-and-excellence-container">
            <CustomTabs tabs={trustAndExcellenceTextContent.content} />
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={trustAndExcellenceTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustAndExcellenceSection;
